import React from 'react';

import styled, { withTheme, keyframes } from 'styled-components';

import ClarusLogo from 'components/ClarusLogo';
const logoAnimation = keyframes`
  0% { opacity: 0; }
  30% { opacity: 1; }
  90% { opacity: 1; }
  100% { opacity: 0; }
`;

const StyledStartLogo = styled.div`
    animation: ${logoAnimation};
    animation-duration: 2s;
    animation-fill-mode: forwards;
`;
const StyledStartScreenContainer = styled.div`
    height: 100vh;
    justify-content: center;
    align-items: center;
    display: flex;
    text-align: center;
    position: fixed;
    top: 0;
    z-index: 1;
    background: #fff;
    width: ${props => props.theme.palette.screen.desktop};
    @media (max-width: 767px) {
        width: ${props => props.theme.palette.screen.smallScreen};
    }
`;
function Splash() {
    return (
        <StyledStartScreenContainer data-testid="m7sqvznq-2dme40">
            <StyledStartLogo data-testid="m7sqvznq-5kf5gb">
                <ClarusLogo data-testid="m7sqvznq-5yt2yg" width="50%" />
            </StyledStartLogo>
        </StyledStartScreenContainer>
    );
}

export default withTheme(Splash);
